// Grouped client for Report operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { DataFormActionResponse } from '../models/DataFormActionResponse';
import { ReportDocumentTemplate } from '../models/ReportDocumentTemplate';
import { UpdateReportDocumentTemplateRequest } from '../models/UpdateReportDocumentTemplateRequest';
import { FilterReportDocumentTemplateRequest } from '../models/FilterReportDocumentTemplateRequest';
import { DataviewReportDocumentTemplateResponse } from '../models/DataviewReportDocumentTemplateResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { DataFormActionResponseSerializer } from '../serializers/DataFormActionResponseSerializer';
import { ReportDocumentTemplateSerializer } from '../serializers/ReportDocumentTemplateSerializer';
import { UpdateReportDocumentTemplateRequestSerializer } from '../serializers/UpdateReportDocumentTemplateRequestSerializer';
import { FilterReportDocumentTemplateRequestSerializer } from '../serializers/FilterReportDocumentTemplateRequestSerializer';
import { DataviewReportDocumentTemplateResponseSerializer } from '../serializers/DataviewReportDocumentTemplateResponseSerializer';

/**
 * HTTP client for Report operations
 *
 * Client for Report operations
 */
export class ReportClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForreportDocumentTemplate(formName: string, objectId: string, contentType?: string | null, storedProcedures?: any | null, inputs?: Record<string, string> | null, template?: string | null, isActive?: boolean | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, flowId?: string | null, objectStatusId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/report.DocumentTemplate({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (storedProcedures !== undefined) {
      queryParams.append('StoredProcedures', String(storedProcedures));
    }
    if (inputs !== undefined) {
      queryParams.append('Inputs', String(inputs));
    }
    if (template !== undefined) {
      queryParams.append('Template', String(template));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypereportDocumentTemplate(formName: string, contentType?: string | null, storedProcedures?: any | null, inputs?: Record<string, string> | null, template?: string | null, isActive?: boolean | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, flowId?: string | null, objectStatusId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/report.DocumentTemplate/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (storedProcedures !== undefined) {
      queryParams.append('StoredProcedures', String(storedProcedures));
    }
    if (inputs !== undefined) {
      queryParams.append('Inputs', String(inputs));
    }
    if (template !== undefined) {
      queryParams.append('Template', String(template));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterReportDocumentTemplate(request?: FilterReportDocumentTemplateRequest | null, options?: { headers?: Record<string, string> }): Promise<ReportDocumentTemplate[]> {
    const path = '/app/api/Object/report.DocumentTemplate/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterReportDocumentTemplateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ReportDocumentTemplateSerializer.fromObject(item));
  }

  async updateReportDocumentTemplate(objectId: string, request?: UpdateReportDocumentTemplateRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/report.DocumentTemplate({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateReportDocumentTemplateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentReportDocumentTemplate(request?: FilterReportDocumentTemplateRequest | null, options?: { headers?: Record<string, string> }): Promise<ReportDocumentTemplate[]> {
    const path = '/app/api/Object/report.DocumentTemplate/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterReportDocumentTemplateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ReportDocumentTemplateSerializer.fromObject(item));
  }

  async dataViewReportDocumentTemplate(request?: FilterReportDocumentTemplateRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewReportDocumentTemplateResponse> {
    const path = '/app/api/Object/report.DocumentTemplate/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterReportDocumentTemplateRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewReportDocumentTemplateResponseSerializer.fromObject(data);
  }

}
